var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['/util/user_agent.js', '/util/etask.js', 'svc_versions', '/util/version_util.js', '/www/hola/pub/lib/model.ts', '/svc/hola/pub/svc_ipc.js', 'pub_config', '/util/url.js', '/svc/vpn/pub/util.js'], function (user_agent, etask, versions, version_util, hola_model, svc_ipc, config, zurl, svc_vpn_util) {
  var b = user_agent.guess_browser();
  var g = user_agent.guess();
  var is_ext_inited, is_svc_inited, is_reg_inited;
  var ext_etask, svc_etask, reg_etask;

  // XXX pavlo: not working for MP use case now
  function msg_post_recv(opt) {
    var msg = opt.msg,
      on_msg;
    return etask([function () {
      on_msg = function (e) {
        if (e.source != top || e.data.src == msg.src || e.data.id != msg.id) return;
        this.continue(e.data);
      }.bind(this);
      try {
        // will init exception on cross origin frame access
        top.addEventListener('message', on_msg);
      } catch (e) {
        this.continue();
        return;
      }
      top.postMessage(msg, '*');
      return this.wait(opt.timeout || 5000);
    }, function finally$() {
      // will init exception on cross origin frame access
      try {
        top.removeEventListener('message', on_msg);
      } catch (e) {}
    }]);
  }
  function check_ext(opt) {
    opt = opt || {};
    return msg_post_recv({
      timeout: opt.timeout || 2000,
      msg: {
        src: 'hola_ccgi',
        id: 'callback'
      }
    });
  }
  function lean_check_ext() {
    return svc_ipc.ext.lean_ping();
  }
  function is_plugin(exe) {
    return /\bhola_plugin/.test(exe);
  }
  function check_svc() {
    return etask([function () {
      return svc_ipc.ajax('callback.json');
    }, function catch$(ret) {
      throw {
        status: ret
      };
    }, function (ret) {
      var data = ret.ret;
      var xhr = ret.xhr;
      return {
        data: data,
        status: xhr.statusText
      };
    }]);
  }
  function get_registry(attrib) {
    return etask([function () {
      return svc_ipc.ajax({
        cmd: 'get_registry.json',
        data: {
          attrib: attrib
        }
      });
    }, function (ret) {
      var data = ret.ret || {};
      return data.value;
    }]);
  }
  var info_model = new hola_model.Model({
    on_svc_detected: [],
    reset: function reset() {
      is_ext_inited = is_svc_inited = is_reg_inited = false;
      ext_etask = svc_etask = reg_etask = undefined;
      config.set_hola_extension_info(undefined);
      this.set('ext_info', undefined);
      this.set('svc_info', undefined);
      this.set('agree_ts', undefined);
    },
    is_latest_ext: function is_latest_ext() {
      var _this = this;
      return etask([function () {
        return _this.get_ext_info();
      }, function (info) {
        if (!info || !info.build_info) return false;
        return version_util.cmp(info.ver, versions[info.build_info.browser_build]) >= 0;
      }]);
    },
    get_ext_info: function get_ext_info() {
      var _this = this;
      return etask([function () {
        if (is_ext_inited) return;
        return _this._check_ext();
      }, function () {
        is_ext_inited = true;
        return _this.get('ext_info');
      }]);
    },
    get_svc_info: function get_svc_info() {
      var _this = this;
      return etask([function () {
        if (is_svc_inited) return;
        return _this._check_svc();
      }, function () {
        is_svc_inited = true;
        return _this.get('svc_info');
      }]);
    },
    get_registry_info: function get_registry_info() {
      // XXX sergeir: don't use agree_ts; use object for all keys
      var _this = this;
      return etask([function () {
        if (is_reg_inited) return;
        return _this._check_registry();
      }, function () {
        is_reg_inited = true;
        return {
          agree_ts: _this.get('agree_ts')
        };
      }]);
    },
    is_ext: function is_ext() {
      var _this = this;
      return etask([function () {
        return _this.get_ext_info();
      }, function (info) {
        return !!info;
      }]);
    },
    is_svc: function is_svc() {
      var _this = this;
      return etask([function () {
        return _this.get_svc_info();
      }, function (info) {
        return !!info && !info.err;
      }]);
    },
    is_latest_svc: function is_latest_svc() {
      var _this = this;
      return etask([function () {
        return _this.get_svc_info();
      }, function (info) {
        if (!info) return false;
        var v_os = g.os == 'macos' ? versions.mac_svc : svc_vpn_util.pick_version(versions, svc_vpn_util.get_product(info.appid), 'windows');
        return version_util.cmp(info.ver, v_os) >= 0;
      }]);
    },
    /**
     * Waits for svc.
     *
     * @param {number} [timeout] Timeout in seconds.
     * @returns {etask} Etask with svc info.
     */
    wait_for_svc: function wait_for_svc(timeout) {
      var _this = this;
      var spent = 0;
      return etask.for(null, function () {
        return etask.sleep(1000);
      }, [function try_catch$() {
        spent++;
        // _check_svc() will not work if we are currently using 'https', so
        // call both, _check_ext() can provide svc info too.
        this.spawn(_this._check_ext());
        this.spawn(_this._check_svc());
        this.spawn(_this._check_registry());
        return this.wait_child('any');
      }, function () {
        return _this.get_svc_info();
      }, function (info) {
        if (info || timeout && spent == timeout) return this.break(info);
      }]);
    },
    /**
     * Waits for latest svc.
     *
     * @returns {etask} Etask with svc info.
     */
    wait_for_new_svc: function wait_for_new_svc() {
      var _this = this;
      return etask.for(null, function () {
        return etask.sleep(1000);
      }, [function try_catch$() {
        // _check_svc() will not work if we are currently using 'https', so
        // call both, _check_ext() can provide svc info too.
        return etask.all({
          ext: _this._check_ext(),
          svc: _this._check_svc()
        });
      }, function () {
        return _this.is_latest_svc();
      }, function (is_latest) {
        if (is_latest) return this.break(_this.get('svc_info'));
      }]);
    },
    /**
     * Waits for latest extension.
     *
     * @param {boolean} [lean=false] Whether we should check using image
     * {@link svc/hola/pub/svc_ipc.js:ext.lean_ping()}.
     * @returns {etask} Etask with extension info.
     */
    wait_for_new_ext: function wait_for_new_ext(lean) {
      var _this = this;
      var previous_init_ts = (_this.get('ext_info') || {}).init_ts;
      return etask.for(null, function () {
        return etask.sleep(1000);
      }, [function try_catch$() {
        if (lean) return lean_check_ext();
        return _this._check_ext();
      }, function (e) {
        if (lean) {
          if (!this.error) return this.break();
          return;
        }
        var new_info = !this.error && e;
        if (!new_info) return;
        // in chrome, chrome.webstore.install will succeed if extension is
        // already the the latest version, but the extension will not be
        // reinstalled (so init_ts will not change).
        if (b.browser == 'chrome' && new_info.init_ts) return this.break();
        if (previous_init_ts == new_info.init_ts) return;
        return this.break(new_info);
      }]);
    },
    _set_ext_info: function _set_ext_info(info) {
      if (!info) return;
      this.set('ext_info', info);
      if (info.svc_info && !info.svc_info.plugin) this.set('svc_info', info.svc_info.raw);
    },
    _check_ext: function _check_ext() {
      var _this = this;
      if (ext_etask) return ext_etask;
      this._set_ext_info(config.get_hola_extension_info());
      ext_etask = etask([function try_catch$() {
        return check_ext();
      }, function (e) {
        ext_etask = null;
        if (this.error || !e || !e.data) return;
        _this._set_ext_info(e.data);
        return e.data;
      }]);
      return ext_etask;
    },
    _check_svc: function _check_svc() {
      var _this = this;
      if (svc_etask) return svc_etask;
      if (window && window.no_svc_check) {
        _this.set('svc_info', undefined);
        return;
      }
      if (window && window.location) {
        var qs = zurl.qs_parse(window.location.search.substr(1), {
          safe: true
        });
        if (qs.debug_svc == 'off') {
          _this.set('svc_info', undefined);
          return;
        } else if (qs.debug_svc) {
          var svc_i_json;
          try {
            svc_i_json = JSON.parse(qs.debug_svc);
          } catch (e) {
            svc_i_json = {
              appid: qs.debug_svc
            };
          }
          console.log('detect debug svc info');
          setTimeout(function () {
            console.log('set debug svc info');
            _this.set('svc_info', svc_i_json);
            if (svc_i_json && svc_i_json.uuid) _this.perr({
              id: 'www_detect_svc',
              info: svc_i_json
            });
          }, 1000);
          return;
        }
      }
      svc_etask = etask([function try_catch$() {
        return check_svc();
      }, function (e) {
        svc_etask = null;
        if (this.error || !e || !e.data) return;
        var info = e.data;
        var v_os = g.os == 'macos' ? versions.mac_svc : svc_vpn_util.pick_version(versions, svc_vpn_util.get_product(info.appid), 'windows');
        info.is_latest_svc = version_util.cmp(info.ver, v_os) >= 0;
        if (is_plugin(info.exe)) return;
        _this.set('svc_info', info);
        if (info && info.uuid) {
          _this.perr({
            id: 'www_detect_svc',
            info: info
          });
          try {
            _this.on_svc_detected.forEach(function (fn) {
              fn({
                info: info
              });
            });
          } catch (e) {}
        }
      }]);
      return svc_etask;
    },
    _check_registry: function _check_registry() {
      var _this = this;
      if (g.os != 'windows') return;
      if (reg_etask) return reg_etask;
      return reg_etask = etask([function try_catch$() {
        return get_registry('agree_ts');
      }, function (e) {
        reg_etask = null;
        if (this.error || !e) return;
        _this.set('agree_ts', e);
      }]);
    },
    perr: function perr() {
      console.warn('not implemented');
    },
    set_perr_fn: function set_perr_fn(fn) {
      this.perr = fn;
    }
  });

  // Singleton.
  return info_model;
});